<header
  class="fixed top-0 left-0 right-0 h-16 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 z-40"
>
  <div class="flex items-center justify-between h-full px-4">
    <!-- Left side: hamburger + logo -->
    <div class="flex items-center space-x-4">
      <!-- Desktop hamburger menu button (visible at lg+ to collapse sidebar) -->
      <button
        type="button"
        class="hidden lg:block p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700"
        (click)="sidebarStore.toggle()"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>

      <!-- Mobile hamburger (visible below lg to open mobile sidebar) -->
      <button
        type="button"
        class="lg:hidden p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700"
        (click)="sidebarStore.toggleMobile()"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>

      <!-- Logo — links to /onboarding/complete during onboarding, /dashboard otherwise -->
      <a [routerLink]="logoLink()" class="flex items-center space-x-3">
        <img src="assets/img/dreampay-logo.svg" alt="DreamPay" class="h-6 w-auto" />
        <span class="text-sm text-gray-500 dark:text-gray-400 hidden sm:inline"
          >Link Generator</span
        >
      </a>
    </div>

    <!-- Center: Tenant Picker -->
    <div class="hidden md:flex items-center">
      <app-tenant-picker />
    </div>

    <!-- Right side: impersonation + language toggle + notifications + user menu -->
    <div class="flex items-center space-x-4">
      <!-- Impersonation Dropdown (SuperUser only, hidden when impersonating) -->
      @if (showImpersonationButton()) {
        <div class="relative impersonation-container">
          <!-- Trigger button -->
          <button
            type="button"
            class="p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700"
            pTooltip="Impersonate user"
            tooltipPosition="bottom"
            (click)="toggleImpersonationDropdown()"
            [attr.aria-expanded]="isDropdownOpen"
            aria-haspopup="true"
          >
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
          </button>

          <!-- Dropdown panel -->
          @if (isDropdownOpen) {
            <div
              class="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50"
            >
              <app-impersonation-dropdown
                #impersonationDropdown
                [currentUser]="authStore.user()"
                (closed)="closeImpersonationDropdown()"
              />
            </div>
          }
        </div>
      }

      <!-- Language Toggle -->
      <app-language-toggle />

      <!-- Pending Invitations -->
      <button
        type="button"
        class="relative p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700"
        pTooltip="Pending Invitations"
        tooltipPosition="bottom"
        (click)="goToInvitations()"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
        @if (pendingInvitationsCount() > 0) {
          <span
            class="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full"
          >
            {{ pendingInvitationsCount() > 9 ? '9+' : pendingInvitationsCount() }}
          </span>
        }
      </button>

      <!-- User Menu -->
      <app-user-menu />
    </div>
  </div>
</header>

<!-- Spacer to push content below fixed header -->
<div class="h-16"></div>
